function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BrowseViewTemplate = require('./browse-view.template');
var CatalogFooterTemplate = require('./catalog-footer.template');
var Teasers = require('./teasers');
var _require = require('./browse-listings'),
  loadListingsPage = _require.loadListingsPage;
var _require2 = require('../categories'),
  DEFAULT_PAGE_SIZE = _require2.DEFAULT_PAGE_SIZE;
var BrowseView = /*#__PURE__*/function () {
  function BrowseView(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, BrowseView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.teasers = new Teasers(app, mod, '.teasers');
    this.category = '';
    this.page = 1;
    this.page_size = DEFAULT_PAGE_SIZE;
    this.listings = [];
    this.pagination = null;
    this.loading = false;
    this.request_token = 0;
    this.has_loaded = false;
  }
  return _createClass(BrowseView, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(BrowseViewTemplate(), this.container);
      this.teasers.container = "".concat(this.container, " .teasers");
      this.renderCatalog();
    }
  }, {
    key: "scrollToListings",
    value: function scrollToListings() {
      var listings = document.querySelector("".concat(this.container, " .catalog")) || document.querySelector("".concat(this.container, " .teasers")) || document.querySelector('.store .catalog');
      if (listings) {
        listings.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }, {
    key: "renderListings",
    value: function renderListings() {
      this.renderCatalog();
    }

    /**
     * Fetch a category page from the Store peer and replace the catalog.
     */
  }, {
    key: "loadPage",
    value: function () {
      var _loadPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _ref,
          _ref$category,
          category,
          _ref$page,
          page,
          _ref$scroll,
          scroll,
          next_category,
          next_page,
          offset,
          token,
          _this$pagination,
          result,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$category = _ref.category, category = _ref$category === void 0 ? this.category : _ref$category, _ref$page = _ref.page, page = _ref$page === void 0 ? this.page : _ref$page, _ref$scroll = _ref.scroll, scroll = _ref$scroll === void 0 ? false : _ref$scroll;
              next_category = String(category || '');
              next_page = Math.max(1, Number(page) || 1);
              offset = (next_page - 1) * this.page_size;
              if (!(this.loading && this.category === next_category && this.page === next_page)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.category = next_category;
              this.page = next_page;
              token = ++this.request_token;
              this.loading = true;
              this.showLoading();
              _context.p = 2;
              _context.n = 3;
              return loadListingsPage(this.app, this.mod, {
                public_key: '',
                category: this.category,
                offset: offset,
                page_size: this.page_size
              });
            case 3:
              result = _context.v;
              if (!(token !== this.request_token)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              this.listings = result.listings || [];
              this.pagination = result.pagination || null;
              this.page = ((_this$pagination = this.pagination) === null || _this$pagination === void 0 ? void 0 : _this$pagination.page) || this.page;
              this.has_loaded = true;
              this.loading = false;
              this.renderCatalog();
              if (scroll) {
                this.scrollToListings();
              }
              _context.n = 7;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              if (!(token !== this.request_token)) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              console.warn('Store: browse load failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
              this.loading = false;
              this.has_loaded = true;
              this.listings = [];
              this.pagination = {
                offset: 0,
                page: 1,
                page_size: this.page_size,
                total: 0,
                total_pages: 0,
                has_next: false,
                has_previous: false
              };
              this.renderCatalog();
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5]]);
      }));
      function loadPage() {
        return _loadPage.apply(this, arguments);
      }
      return loadPage;
    }()
  }, {
    key: "showLoading",
    value: function showLoading() {
      var status = document.querySelector("".concat(this.container, " [data-catalog-status]"));
      var teasers = document.querySelector("".concat(this.container, " .teasers"));
      var footer = document.querySelector("".concat(this.container, " [data-catalog-footer]"));
      if (status) {
        status.hidden = false;
        status.innerHTML = "\n        <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n        <p>Loading listings\u2026</p>\n      ";
      }
      if (teasers) {
        teasers.innerHTML = '';
        teasers.hidden = true;
      }
      if (footer) {
        footer.hidden = true;
        footer.innerHTML = '';
      }
    }
  }, {
    key: "renderCatalog",
    value: function renderCatalog() {
      var _this$pagination$tota, _this$pagination2;
      var status = document.querySelector("".concat(this.container, " [data-catalog-status]"));
      var teasers = document.querySelector("".concat(this.container, " .teasers"));
      var footer = document.querySelector("".concat(this.container, " [data-catalog-footer]"));
      if (!teasers) {
        return;
      }
      if (this.loading) {
        this.showLoading();
        return;
      }
      if (!this.has_loaded) {
        if (status) {
          status.hidden = false;
          status.innerHTML = "\n          <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n          <p>Connecting to Store\u2026</p>\n        ";
        }
        if (teasers) {
          teasers.innerHTML = '';
          teasers.hidden = true;
        }
        if (footer) {
          footer.hidden = true;
          footer.innerHTML = '';
        }
        return;
      }
      if (status) {
        status.hidden = true;
        status.innerHTML = '';
      }
      var total = Number((_this$pagination$tota = (_this$pagination2 = this.pagination) === null || _this$pagination2 === void 0 ? void 0 : _this$pagination2.total) !== null && _this$pagination$tota !== void 0 ? _this$pagination$tota : this.listings.length);
      var empty = total === 0;
      if (empty) {
        teasers.hidden = true;
        teasers.innerHTML = '';
        if (footer) {
          footer.hidden = false;
          footer.innerHTML = CatalogFooterTemplate({
            empty: true,
            categoryLabel: this.category
          });
        }
        return;
      }
      teasers.hidden = false;
      this.teasers.render("".concat(this.container, " .teasers"), this.returnVisibleListings());
      if (footer) {
        footer.hidden = false;
        footer.innerHTML = CatalogFooterTemplate({
          pagination: this.pagination,
          empty: false,
          categoryLabel: this.category
        });
        this.attachFooterEvents(footer);
      }
    }
  }, {
    key: "attachFooterEvents",
    value: function attachFooterEvents(footer) {
      var _this = this;
      footer.querySelectorAll('[data-page]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          var page = Number(btn.getAttribute('data-page'));
          if (page && page !== _this.page) {
            _this.loadPage({
              page: page,
              scroll: true
            });
          }
        };
      });
      var prev = footer.querySelector('[data-page-action="prev"]');
      if (prev) {
        prev.onclick = function (e) {
          var _this$pagination3;
          e.preventDefault();
          if ((_this$pagination3 = _this.pagination) !== null && _this$pagination3 !== void 0 && _this$pagination3.has_previous) {
            _this.loadPage({
              page: _this.page - 1,
              scroll: true
            });
          }
        };
      }
      var next = footer.querySelector('[data-page-action="next"]');
      if (next) {
        next.onclick = function (e) {
          var _this$pagination4;
          e.preventDefault();
          if ((_this$pagination4 = _this.pagination) !== null && _this$pagination4 !== void 0 && _this$pagination4.has_next) {
            _this.loadPage({
              page: _this.page + 1,
              scroll: true
            });
          }
        };
      }
    }
  }, {
    key: "returnVisibleListings",
    value: function returnVisibleListings() {
      var lifecycle = this.mod.purchase_lifecycle;
      if (!(lifecycle !== null && lifecycle !== void 0 && lifecycle.isListingHidden)) {
        return this.listings;
      }
      return this.listings.filter(function (summary) {
        return !lifecycle.isListingHidden(summary);
      });
    }
  }]);
}();
module.exports = BrowseView;